module.exports = __webpack_public_path__ + "img/news.4c62c73f.png";